'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _analyticsMarketing = require('./analytics-marketing.component');

var _analyticsMarketing2 = _interopRequireDefault(_analyticsMarketing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var analyticsModule = _angular2.default.module('app.containers.analytics-marketing', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('analyticsMarketing', {
    url: '/analytics-marketing',
    template: '<analytics-marketing></analytics-marketing>'
  });
}).component('analyticsMarketing', _analyticsMarketing2.default);

exports.default = analyticsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/analytics-marketing/analytics-marketing.js
 **/